import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const translations = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    data: {},
    upcharge: {}
  }
};

export default translations;
